import { render, staticRenderFns } from "./password-recovery.vue?vue&type=template&id=bab645ea&scoped=true"
import script from "./password-recovery.vue?vue&type=script&lang=js"
export * from "./password-recovery.vue?vue&type=script&lang=js"
import style0 from "./password-recovery.vue?vue&type=style&index=0&id=bab645ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bab645ea",
  null
  
)

export default component.exports